import { render, staticRenderFns } from "./KamModal.vue?vue&type=template&id=bc2ef020"
import script from "./KamModal.vue?vue&type=script&lang=js"
export * from "./KamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports